import React from 'react';

import { baseURL } from 'src/config';
import './features.css';

export default class Features extends React.Component {
  render() {
    return (
      <section className="features">
        <h2 className="features-title">Scouting as a service.</h2>
        <div className="features-row">
          <div className="features-col">
            <h3 className="features-col-title">Video</h3>
            <img
              className="contain features-image"
              src={`${baseURL}/images/features-video.jpg`}
              alt="Video"
            />
            <h4 className="features-col-subtitle">Dead simple replays.</h4>
            <div className="features-col-body">
              Thousands of hours of gameplay on demand, overview and POV, plus cutups of teams and
              players by map, side, and more.
            </div>
          </div>
          <div className="features-col">
            <h3 className="features-col-title">Heatmaps</h3>
            <img
              className="contain features-image"
              src={`${baseURL}/images/features-heatmaps.jpg`}
              alt="Heatmap"
            />
            <h4 className="features-col-subtitle">A picture is worth 1,000 kills.</h4>
            <div className="features-col-body">
              Analyze trends in movement, weapon fire, kills, damage, bomb events, and grenades
              across hundreds of matches.
            </div>
          </div>
          <div className="features-col">
            <h3 className="features-col-title">Stats</h3>
            <img
              className="contain features-image"
              src={`${baseURL}/images/features-stats.png`}
              alt="Stats"
            />
            <h4 className="features-col-subtitle">Go beyond the basics.</h4>
            <div className="features-col-body">
              Over 400,000+ rounds for top tier events, with dashboards and scouting reports for
              players, teams, and lineups.
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/features.js